import { subscribeToNewsletter } from 'lib/helpers';

import {
  Button,
  FieldWrapper,
  flash,
  Form,
  Heading,
  InputWrapper,
  Label,
  TextInput,
} from '@frontendmentorio/design-system-v2';

export default function Newsletter() {
  const handleSubmit = async (data, state, methods) => {
    try {
      await subscribeToNewsletter(data);
      methods.reset();
      flash.success("You're now subscribed to our newsletter! 🎉");
    } catch (error) {
      flash.error(error.message);
    }
  };

  return (
    <div className="flex flex-col gap-4 max-w-[28rem] w-full">
      <p className="flex flex-col gap-2">
        <Heading
          className="text-blue-800 leading-normal"
          level="5"
          tagName="span"
        >
          Stay up to date
        </Heading>

        <span>
          with new challenges, featured solutions, selected articles, and our
          latest news
        </span>
      </p>

      <Form
        className="flex flex-col gap-4 mobile:flex-row mobile:items-start"
        onSubmit={handleSubmit}
      >
        <FieldWrapper className="w-full">
          <Label className="sr-only">Email</Label>

          <InputWrapper
            input={TextInput}
            name="email"
            placeholder="email@example.com"
            type="email"
            validations={{ email: true, required: true }}
          />
        </FieldWrapper>

        <Button>Subscribe</Button>
      </Form>
    </div>
  );
}
